"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useDebounce = (func, timeout = 300) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
};
exports.default = useDebounce;
//# sourceMappingURL=use-debounce.js.map